export default "__VITE_ASSET__icS52RsA__"